export default __webpack_public_path__ + "static/media/truckBg.c6d3b08c.png";